import { makeStyles } from 'tss-react/mui'
import { Property } from 'csstype'

export const useStyles = makeStyles()(theme => ({
  productTypeContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1.5),
  },
  textHeading: {
    fontFamily: theme.typography.fontFamily,
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.15px',
    color: theme.palette.labraCheckbox.main,
  },
  sectionHeading: {
    fontFamily: theme.typography.fontFamily,
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.15px',
    color: theme.palette.labraCheckbox.main,
  },
  sectionText: {
    fontSize: '14px !important' as any,
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px !important' as any,
    letterSpacing: '0.25px',
    color: '#2E3132',
    fontFamily: theme.typography.fontFamily,
    textAlign: 'left',
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
  },
  sectionContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%',
  },
  sectionHeadingContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  companyDetailsContainer: {
    display: 'flex',
    gap: theme.spacing(3),
    width: '100%',
  },
  inputWidth: {
    width: '50%',
  },
  radioButton: {
    '& .MuiFormGroup-root': {
      flexDirection: 'column !important' as Property.FlexDirection,
      gap: theme.spacing(1),
    },
    '& .MuiFormControlLabel-root': {
      maxWidth: 'fit-content !important',
    },
  },
  textField: {
    marginTop: theme.spacing(2.5),
  },
  renewalChannelMragin: {
    marginBottom: theme.spacing(1.5),
  },
  textFieldMargin: {
    marginBottom: theme.spacing(2),
  },
  radioClass: {
    '& .MuiFormGroup-root': {
      flex: 0,
    },
  },
  widthRadio: {
    width: 'auto',
  },
  radioWithRadio: {
    '& > div > div > div': {
      width: '100%',
    },
  },
  partnerTypeError: {
    fontStyle: theme.typography.fontFamily,
    color: theme.palette.labraV2Errors.main,
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
  },
  gapError: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
  },
}))
